export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const generateArrayOfMonths = () => {
  return MONTH_NAMES.map((month, index) => ({
    label: month,
    value: String(index + 1).padStart(2, "0"),
  }));
};

export const generateArrayOfYears = (maxYear = new Date().getFullYear()) => {
  const currentYear = new Date().getFullYear();
  const years = [];

  const endYear = Math.min(currentYear, maxYear); // Use maxYear if provided, otherwise default to currentYear
  const startYear = endYear - 10; // Generate the last 10 years from the endYear

  for (let i = endYear; i > startYear; i--) {
    years.push({ label: i, value: i, name: "year" });
  }

  return years;
};

export const getDayNames = () => {
  const days = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(2024, 0, i);
    days.push(date.toLocaleDateString("id-ID", { weekday: "short" }));
  }
  return days;
};

export const generateMonthDates = (refDate = new Date()) => {
  const d = new Date(refDate);
  const year = d.getFullYear();
  const month = d.getMonth();
  const start = new Date(year, month, 1);
  const end = new Date(year, month + 1, 0);

  const dates = [];
  for (let cur = new Date(start); cur <= end; cur.setDate(cur.getDate() + 1)) {
    const yyyy = cur.getFullYear();
    const mm = String(cur.getMonth() + 1).padStart(2, "0");
    const dd = String(cur.getDate()).padStart(2, "0");
    dates.push(`${yyyy}-${mm}-${dd}`);
  }
  return dates;
};

export const formatDate = (input) => {
  if (!input) return null;
  if (typeof input === "string") {
    const match = input.match(/^(\d{4}-\d{2}-\d{2})/);
    if (match) return match[1];
  }
  const d = new Date(input);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
